module.exports = __webpack_public_path__ + "files/57fa1bc729c23b4f3543b316d3a4a434.png";